import React, { FC } from 'react';
import classNames from 'classnames';

import css from './style.module.scss';
import Icon from '@sv-support-sdk/ui-components/src/components/Media/Icon';

interface IProps {
  text: string;
  extension: string;
  className?: string;
  onClose?: () => void;
  url?: string;
}

const DocumentTag: FC<IProps> = ({ text, className, onClose, url, extension }) => (
  <a href={url} className={classNames(css.documentTag, className)}>
    <span className={css.documentTag__content}>
      <span className={css.documentTag__icon}>
        <Icon
          id={extension === 'pdf' ? 'colored--24--pdf-document' : 'colored--28--image-document'}
        />
      </span>
      <span className={css.documentTag__text}>{text}</span>
      {onClose && (
        <span onClick={onClose} className={css.documentTag__close}>
          <Icon id="24--trash-bin" />
        </span>
      )}
    </span>
  </a>
);

export default DocumentTag;
